import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "color", "size"];
import clsx from "clsx";
import React, { useCallback, useState } from "react";
import Script from 'next/script';
import { Checkbox } from "./checkbox";
import { z } from "zod";
import axios from "axios";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var isEmail = z.string().email();
export var Subscribe = props => {
  var {
    size = "md"
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var [email, setEmail] = useState("");
  var [privacy, setPrivacy] = useState(false);
  var [showSuccess, setShowSuccess] = useState(false);
  var [submitting, setSubmitting] = useState(false);
  var subscribe = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (event) {
      event == null ? void 0 : event.preventDefault();

      if (!isEmail.safeParse(email)) {
        return;
      }

      setSubmitting(true);
      grecaptcha.ready(function () {
        var action = 'emailSubscribe';
        grecaptcha.execute('6LdVoXkUAAAAAJSPi9AzIFrcumZGtaqoD7vc_nHH', {
          action
        }).then(function (gaToken) {
          console.log(gaToken);
          axios.post(process.env.NEXT_PUBLIC_API_URL + "/api/v1/subscribe", {
            gaToken,
            email,
            action
          }).then(res => res.data).then(res => {
            setShowSuccess(true);
          }).catch(e => {//
          }).finally(() => {
            setSubmitting(false);
          });
        });
      });
    });

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [email]);
  return /*#__PURE__*/_jsxs("div", {
    className: "w-full group",
    children: [/*#__PURE__*/_jsx(Script, {
      id: "recaptcha-js",
      src: "https://www.google.com/recaptcha/api.js?render=6LdVoXkUAAAAAJSPi9AzIFrcumZGtaqoD7vc_nHH",
      onLoad: () => {}
    }), /*#__PURE__*/_jsxs("form", _extends({
      onSubmit: subscribe,
      action: "#",
      className: clsx(" flex w-full mb-2 ")
    }, rest, {
      children: [/*#__PURE__*/_jsx("input", {
        value: email,
        type: "email",
        placeholder: "Please enter your email here",
        disabled: submitting,
        onChange: event => setEmail(event.target.value),
        className: clsx("flex-1 pl-3 pr-6 py-1 focus:outline-none border border-grey-50  outline-none focus:ring-0 shadow border-r-0 rounded-tl-xl rounded-bl-xl", {
          hidden: showSuccess
        })
      }), /*#__PURE__*/_jsx("button", {
        type: "submit",
        disabled: submitting || showSuccess || !privacy,
        className: clsx("flex relative justify-self-end   transition-width duration-300   overflow-hidden  shadow-md    justify-center text-grey-900 items-center    px-1 h-11 rounded-2xl bg-ccq-yellow", {
          "bg-ccq-yellow/60": submitting || !privacy
        }, showSuccess ? " w-full ml-auto" : " shrink  rounded-tl-none rounded-bl-none  w-11"),
        children: submitting ? /*#__PURE__*/_jsxs("svg", {
          className: "animate-spin   h-5 w-5  shrink",
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24",
          children: [/*#__PURE__*/_jsx("circle", {
            className: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "4"
          }), /*#__PURE__*/_jsx("path", {
            className: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })]
        }) : showSuccess ? /*#__PURE__*/_jsxs("div", {
          className: "flex gap-3 w-full max-w-md items-center justify-center px-2",
          children: [/*#__PURE__*/_jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            strokeWidth: 1.5,
            stroke: "currentColor",
            className: "w-6 h-6 p-1  rounded-full border border-black",
            children: /*#__PURE__*/_jsx("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              d: "M4.5 12.75l6 6 9-13.5"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "font-bold",
            children: "Thank you for subscribing"
          })]
        }) : /*#__PURE__*/_jsxs("div", {
          className: "relative",
          children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            strokeWidth: 1.5,
            stroke: "currentColor",
            className: "absolute -left-3 -top-3 w-6 h-6 -rotate-45 duration-700 transition-transform group-hover:translate-x-10 group-hover:-translate-y-10",
            children: /*#__PURE__*/_jsx("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              d: "M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
            })
          }), /*#__PURE__*/_jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            strokeWidth: 1.5,
            stroke: "currentColor",
            className: "absolute -left-3 -top-3 inset-0 w-6 h-6 -rotate-45  duration-700  transition-transform  -translate-x-10  translate-y-10 group-hover:translate-x-0 group-hover:translate-y-0",
            children: /*#__PURE__*/_jsx("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              d: "M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
            })
          })]
        })
      })]
    })), /*#__PURE__*/_jsx("div", {
      className: clsx("text-md  text-grey-500 mt-4 mb-3 ", {
        "opacity-0": showSuccess
      }),
      children: /*#__PURE__*/_jsx(Checkbox, {
        className: "justify-center items-center gap-2",
        id: "privacy",
        onChange: setPrivacy,
        checked: privacy,
        boxClassName: clsx({
          "border border-ccq-yellow": !privacy
        }),
        children: "Yes, I have read Cancer Council\u2019s privacy collection statement"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "text-xs text-center text-grey-500",
      children: ["This site is protected by reCAPTCHA and the Google ", /*#__PURE__*/_jsx("a", {
        target: "_blank",
        href: "https://policies.google.com/privacy",
        children: "Privacy Policy"
      }), " and ", /*#__PURE__*/_jsx("a", {
        href: "https://policies.google.com/terms",
        target: "_blank",
        children: "Terms of Service"
      }), " apply."]
    })]
  });
};
//# sourceMappingURL=subscribe.js.map